import { FC, ReactNode, useEffect, useState } from 'react';

import { useLocation } from '@xing-com/crate-core-router';
import { PlayerProps } from '@xing-com/crate-video-player';

type ParentConfiguration = PlayerProps['configuration'];

type Props = {
  children: ({
    configuration,
  }: {
    configuration: ParentConfiguration;
  }) => ReactNode;
};
export const ParentConfiguration: FC<Props> = ({ children }) => {
  const { search } = useLocation();

  const searchParams = new URLSearchParams(search);

  const [configuration, setConfiguration] =
    useState<ParentConfiguration | null>(null);

  const waitForConfiguration = (querystring: URLSearchParams): void => {
    let configTimer: number;

    window.addEventListener('message', (event) => {
      let data;

      try {
        data = JSON.parse(event.data);
      } catch {
        return;
      }

      if (data.type !== 'video_configuration') {
        return;
      }

      clearTimeout(configTimer);
      setConfiguration(data.data);
    });

    // in the webview we won't execute any JS, so we should not wait for the configuration.
    // we will assume default values
    if (querystring.get('inWebview') === 'true') {
      setConfiguration({});
    } else {
      // if we don't receive a configuration in x seconds we'll assume that the configuration is empty
      configTimer = setTimeout((_) => setConfiguration({}), 2000);
    }
  };

  useEffect(() => {
    waitForConfiguration(searchParams);

    if (!configuration) {
      const postMessageConfiguration = {
        type: 'video_manager_get_configuration',
        id: searchParams.get('id'),
      };

      window.parent.postMessage(JSON.stringify(postMessageConfiguration), '*');
    }
  }, []);

  if (!configuration) {
    return null;
  }

  return children({ configuration });
};
